export default __webpack_public_path__ + "static/media/filter-icons-close.88a5f083.svg";